import React from "react";
import { Button, Card, Modal, Col, Form, Input, Row, Switch, Cascader, DatePicker, notification } from "antd";
import { connect } from 'react-redux';
import { createStore, fetchStores, createStoreWithImage } from "appRedux/actions/Coupons";

const FormItem = Form.Item;

class Basic extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchStores();
  }

  state = {
    visible: false,
    name: '', phone: '', email: ''
    , active: 1,
    validateStatusNombre: '', helpNombre: '',
    validateStatusEmail: '', helpEmail: '',
    validateStatusNumber: '', helpStatusNumber: ''
  };

  showModal = () => {
    this.setState({
      visible: true,

    });
  };

  handleCancel = (e) => {
    this.setState({
      name: '',
      phone: '',
      email: '',
    });

    this.props.fetchStores();
    this.setState({ visible: false });

    if (this.state.name == '') { this.setState({ validateStatusNombre: '', helpNombre: '', }); }
    if (this.state.email == '') { this.setState({ validateStatusEmail: '', helpEmail: '', }); }
    if (this.state.phone == '') { this.setState({ validateStatusNumber: '', helpStatusNumber: '', }); }

  };


  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El registro de la tienda se ha creado con éxito.',
      });
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al registrar la tienda.',
      });
    }

  };


  onChangeS = (checked) => {
    if (checked) {
      this.setState({ active: 1 });
    } else { this.setState({ active: 0 }); }
  }


  onHandleClick = (event) => {
    event.preventDefault();
    let { name, email, phone } = this.state;
    if (name && email && phone) {
      //this.props.createStore(this.state, () => { this.props.fetchStores(); });
      this.props.createStoreWithImage(this.state, () => { this.props.fetchStores(); });
      this.setState({
        name: '', phone: '', email: ''
      });
      this.onNotification('success');
    } else {

      if (this.state.name == '') { this.setState({ validateStatusNombre: 'error', helpNombre: 'Nombre es un campo obligatorio.', }); } else { this.setState({ validateStatusNombre: '', helpNombre: '' }); }
      if (this.state.phone == '') { this.setState({ validateStatusNumber: 'error', helpStatusNumber: 'Teléfono es un campo obligatorio.', }); } else { this.setState({ validateStatusNumber: '', helpStatusNumber: '' }); }
      if (this.state.email == '') { this.setState({ validateStatusEmail: 'error', helpEmail: 'Correo es un campo obligatorio.', }); } else { this.setState({ validateStatusEmail: '', helpEmail: '' }); }

      let messageError = 'Rellene los campos obligatorios.';
      this.onNotification('error', messageError);
    }
  }


  handlChangeImage = (selectorFiles) => {
    const file = selectorFiles[0];
    this.setState({ imageUrl: file });
  }

  render() {
    return (
      <div >
        <Button type="primary" onClick={this.showModal}>Crear tienda</Button>
        <Modal
          afterClose={() => this.props.fetchStores()}
          okText="Crear"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >




          <Card className="gx-card" title="Nueva tienda">
            <form onSubmit={this.onHandleClick}>
              <Row>
                <Col lg={12} md={12} sm={12} xs={24} >

                  <FormItem label='Tienda *:' labelCol={{ xs: 9, sm: 9, lg: 9, md: 9 }} validateStatus={this.state.validateStatusNombre} help={this.state.helpNombre}>
                    <Input
                      required
                      placeholder="Nombre de la tienda"
                      value={this.state.name}
                      onChange={

                        (event) => {
                          this.setState({
                            name: event.target.value
                          });

                          if (event.target.value != '') { this.setState({ validateStatusNombre: '', helpNombre: '' }); } else { this.setState({ validateStatusNombre: 'error', helpNombre: 'Nombre es un campo obligatorio.' }); }


                        }
                      }
                    />
                  </FormItem>

                </Col>


                <Col lg={12} md={12} sm={12} xs={24} >
                  <FormItem label='Teléfono :' labelCol={{ xs: 9, sm: 9, lg: 9, md: 9 }}>
                    <Input
                      required
                      placeholder="Número de teléfono"
                      value={this.state.phone}
                      onChange={
                        (event) => {
                          this.setState({
                            phone: event.target.value
                          });
                          if (event.target.value != '') { this.setState({ validateStatusNumber: '', helpStatusNumber: '' }); } else { this.setState({ validateStatusNumber: 'error', helpStatusNumber: 'Teléfono es un campo obligatorio.' }); }
                        }
                      }
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24} >
                  <FormItem label='Correo *:' labelCol={{ xs: 10, sm: 10, lg: 10, md: 10 }} validateStatus={this.state.validateStatusEmail} help={this.state.helpEmail}   >
                    <Input
                      required
                      placeholder="Correo electrónico"
                      value={this.state.email}
                      onChange={
                        (event) => {
                          this.setState({
                            email: event.target.value
                          });
                          if (event.target.value != '') { this.setState({ validateStatusEmail: '', helpEmail: '' }); } else { this.setState({ validateStatusEmail: 'error', helpEmail: 'Correo es un campo obligatorio.' }); }
                        }
                      }
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24} >
                  <Card
                    type="inner"
                    title="Foto de la tienda"
                  >
                    <FormItem label='Tamaño: (200 x 200 px)' labelCol={{ xs: 24, sm: 24, lg: 24, md: 24 }} ></FormItem>
                    <input
                      type="file"
                      onChange={
                        (event) => {
                          this.handlChangeImage(event.target.files)
                        }
                      }
                    />
                  </Card>
                </Col>


                <Col lg={12} md={12} sm={12} xs={24}  >
                  <FormItem label='Activo *:' labelCol={{ xs: 9, sm: 9, lg: 9, md: 9 }}>
                    <Switch defaultChecked={true} onChange={this.onChangeS} />
                  </FormItem>
                </Col>


              </Row>


            </form>
          </Card>







        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ placeStores }) {
  return {
    placeStores
  }
}

export default connect(mapStateToProps, { fetchStores, createStore, createStoreWithImage })(Basic);


// WEBPACK FOOTER //
// ./src/routes/main/Store/Modal.js